/**
 * 密码校验 支持特殊符号/大小写
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validatePasswordRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('请输入密码！'))
    } else if ( !/^[A-Za-z0-9_\-.+=/@!#$%^&?*]+$/.test(value)) {
        return callback(new Error('密码格式错误,仅支持英文和数字和以下字符：_.-+=/@!#$%^&?*'))
    } else if (value.length < 6) {
        return callback(new Error('长度不能低于6位！'))
    } else {
        return callback()
    }
}

/**
 * 账号校验 支持特殊符号/大小写
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateAccountRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('请输入账号！'))
    } else if ( !/^[A-Za-z0-9]+$/.test(value)) {
        return callback(new Error('账号格式错误,仅支持英文和数字'))
    } else if (value.length < 6) {
        return callback(new Error(''))
    } else {
        return callback()
    }
}

/**
 * 数字校验 选填
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateNumber = (rule, value, callback) => {
    if ( !value && value !== 0) {
        return callback()
    } else {
        if ( !/^\d+$/.test(value)) {
            return callback(new Error('仅支持正整数!'))
        } else if (String(value).length > 1 && /^0/.test(value)) {
            return callback(new Error('数字首位不能为0!'))
        } else {
            return callback()
        }
    }
}
/**
 * 数字校验 + 小数 必填
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateNumberRequire = (rule, value, callback) => {
    if (value || +value === 0) {
        if ( !/^\d+$/.test(value)) {
            return callback(new Error('仅支持正整数!'))
        } else if (String(value).length > 1 && /^0/.test(value)) {
            return callback(new Error('数字首位不能为0!'))
        } else {
            return callback()
        }
    } else {
        return callback()
    }
}


/**
 * 整数或者保留两位小数校验
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateTwoDecimalPlaces = (rule, value, callback) => {
    if (value && !/^-?\d+(?:\.\d{1,2})?$/.test(value)) {
        return callback(new Error('仅支持整数或者保留两位小数'))
    } else {
        return callback()
    }
}

/**
 * 验证码校验
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateNumEng = (rule, value, callback) => {
    if (value && !/^[A-Za-z0-9]+$/.test(value)) {
        return callback(new Error('仅支持英文和数字'))
    } else {
        return callback()
    }
}
/**
 * 数字和英文校验 必填
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateNumEngRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('该项为必填'))
    } else if ( !/^[A-Za-z0-9]+$/.test(value)) {
        return callback(new Error('仅支持英文和数字'))
    } else {
        return callback()
    }
}

/**
 * 电子邮箱校验
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 * \u4e00-\u9fa5 汉字
 */
export const validateEmail = (rule, value, callback) => {
    if ( !value) {
        return callback()
    } else if ( !/^[A-Za-z0-9]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
        return callback(new Error('邮箱格式不正确，仅支持英文和数字、com'))
    }else{
        return callback()
    }
}

/**
 * 电子邮箱校验
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateEmailRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('请输入邮箱！'))
    } else if (value.length > 30) {
        return callback(new Error('邮箱不能超过30位数！'))
    } else if ( !/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
        return callback(new Error('邮箱格式不正确！'))
    } else {
        return callback()
    }
}

/**
 * 身份证校验
 * @param rule
 * @param value
 * @param callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateIdNumber = (rule, value, callback) => {
    const _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    const _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
    if (value && !_IDRe18.test(value) && !_IDre15.test(value)) {
        return callback(new Error('身份证格式错误！'))
    } else {
        callback()
    }
}

/**
 * 身份证校验
 * @param rule
 * @param value
 * @param callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateIdNumberRequired = (rule, value, callback) => {
    const _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    const _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
    if ( !value) {
        return callback(new Error('请输入身份证号！'))
    } else if ( !_IDRe18.test(value) && !_IDre15.test(value)) {
        return callback(new Error('身份证格式错误'))
    } else {
        callback()
    }
}
/**
 * 手机号校验 必填
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validatePhoneRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('该项为必填！'))
    } else if ( !/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error('电话号码格式错误'))
    } else if (String(value).length !== 11) {
        return callback(new Error('联系方式必须为11位！'))
    } else {
        callback()
    }
}
/**
 * 手机号校验 选填
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validatePhone = (rule, value, callback) => {
    if (value) {
        if ( !/^1[3456789]\d{9}$/.test(value)) {
            return callback(new Error('电话号码格式错误'))
        } else if (String(value).length !== 11) {
            return callback(new Error('联系方式必须为11位！'))
        } else {
            callback()
        }
    } else {
        callback()
    }
}

/**
 * 字数校验 20个字
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validate20Words = (rule, value, callback) => {
    if (value && String(value).length > 20) {
        return callback(new Error('不能超过20字！'))
    } else {
        callback()
    }
}

/**
 * 字数校验 20个字
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validate20WordsRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('该项为必填！'))
    } else if (String(value).length > 20) {
        return callback(new Error('不能超过20字！'))
    } else {
        callback()
    }
}

/**
 * 字数校验 50个字
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validate50WordsRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('该项为必填！'))
    } else if (value && String(value).length > 50) {
        return callback(new Error('不能超过50字！'))
    } else {
        callback()
    }
}

/**
 * 字数校验 非必填，但限制50个字
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validate50Words = (rule, value, callback) => {
    if (value && String(value).length > 50) {
        return callback(new Error('不能超过50字！'))
    } else {
        callback()
    }
}

/**
 * 字数校验 非必填，但限制200个字
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validate200Words = (rule, value, callback) => {
    if (value && String(value).length > 200) {
        return callback(new Error('不能超过200字！'))
    } else {
        callback()
    }
}

/**
 * 字数校验 必填，限制200个字
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validate200WordsRequired = (rule, value, callback) => {
    if ( !value) {
        return callback(new Error('此为必填项！'))
    } else if (String(value).length > 200) {
        return callback(new Error('不能超过200字！'))
    } else {
        callback()
    }
}

/* 微信号格式校验
 * @params rule
 * @params value
 * @params callback
 * @returns {Promise<never>|Promise<void>}
 */
export const validateWechat = (rule, value, callback) => {
    if (value && !/^[a-zA-Z0-9][a-zA-Z0-9_-]{5,19}$/.test(value)) {
        return callback(new Error('微信号格式错误！'))
    } else {
        callback()
    }
}

// 必填项
export const validateRequired = (rule, value, callback) => {
    if ( !value && ![0, '0'].includes(value)) {
        return callback(new Error('该项为必填！'))
    } else {
        callback()
    }
}
